<template>
  <div class="padding">
    <div class="app-container">
    <el-row>
      <el-col :span="6">
        <el-tree :data="treeDataMenu" :props="treeProps" default-expand-all @node-click="handleNodeClick" ref="planTree"></el-tree>
      </el-col>
      <el-col :span="10" :offset="2">
        <div style="padding: 0px 10px 10px 10px;">
          <el-button plain size="small" @click="openItem('add')">添加一级施工项</el-button>
          <el-button plain size="small" @click="openItem('update')">修改一级施工项</el-button>
          <el-button plain size="small" @click="delItem()">删除一级施工项</el-button>
        </div>
        <div v-show="isShow">
          <el-button type="success" @click="openItems('add',null)" style="margin-bottom: 10px">新增</el-button>
          <el-table :data="planTableData" border style="width: 100%">
            <el-table-column prop="id" label="序号" width="100" align="center"></el-table-column>
            <el-table-column prop="name" label="施工项" align="center"></el-table-column>
            <el-table-column label="操作" width="200" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" @click="openItems('update',scope.row.id)">修改</el-button>
                <el-button size="mini" type="danger" @click="del(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="新增/修改一级施工阶段" :visible.sync="dialogItemVisible">
      <el-form ref="planTable" :model="planTable" label-width="80px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="一级施工项">
              <el-select v-model="planTable.code" size="small" placeholder="请选择模板状态" @change="setName">
                <el-option :label="item.name" :value="item.code" v-for="(item, index) in constructionItems" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="历时天数">
              <el-input :maxlength="100" v-model.trim="planTable.days" size="small" placeholder="请输入历时天数"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="付款周期">
              <el-select v-model="planTable.payRange" size="small" placeholder="请选择付款周期" @change="setName">
                <el-option :label="item.name" :value="item.code" v-for="(item, index) in payments" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="排序">
              <el-input :maxlength="100" v-model.trim="planTable.order" size="small" placeholder="请输入排序"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <div style="padding: 0px 10px 10px 10px;">
            <el-button plain size="small" @click="addItem()">确认</el-button>
            <el-button plain size="small" @click="closeWindow()">取消</el-button>
          </div>
        </el-row>
      </el-form>
    </el-dialog>
    <el-dialog title="新增施工阶段" :visible.sync="dialogItemVisibles">
      <el-form>
        <el-row>
          <el-col :span="8">
            <el-form-item label="施工项">
              <el-input :maxlength="100" v-model="planTables.name" size="small" placeholder="请输入施工项"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="排序">
              <el-input :maxlength="100" v-model.trim="planTables.order" size="small" placeholder="请输入排序"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <div style="padding: 0px 10px 10px 10px;">
            <el-button plain size="small" @click="addItems()">确认</el-button>
            <el-button plain size="small" @click="closeWindow()">取消</el-button>
          </div>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
  </div>
</template>

<script>
  import formMixins from '@/mixins/form'
  import treeUtil from '@/utils/tree';

  export default {
    mixins: [formMixins , treeUtil],
    data() {
      return {
        planTableData:[],
        constructionItems:this.$cache.getDic("construction_item"),
        payments:this.$cache.getDic("payment_periods"),
        selectItem:'',
        planTable:{
          id:'',
          tplId:'',
          name:'',
          parentId:'',
          days:'',
          creater:'',
          createrName:'',
          createTime:'',
          modifier:'',
          modifierName:'',
          modifyTime:'',
          payRange:'',
          order:'',
        },
        planTables:{
          name:'',
          code:'',
          parentId:'',
          order:'',
        },
        dialogItemVisible:false,
        dialogItemVisibles:false,
        checkNode:null,
        isShow:false,
        parentCode:'',
        parId:'',
        treeDataMenu:[],
        treeProps: {
          children: 'children',
          label: 'name',
        },
        tableData:[],
        updateType:'',
      }
    },
    created() {
      // 调用全局混合方法 第一个参数是请求地址对应的名称（api.js），第二个为参数
      // this.initTableData(this.$api.fwRoleList.queryPage, this.params)
      this.refresh()
    },
    methods:{
      //打开新增一级施工项窗口
      openItem(type){
        this.updateType = type
        if(type=='add'){
          this.planTable = {}
          this.dialogItemVisible = true
        }else if(type=='update'){
          console.log(this.planTable)
          if(this.planTable.id != ""){
            if(this.planTable.parentId == "" || this.planTable.parentId == null){
              this.dialogItemVisible = true
            }else{
              this.$message.error('请选择一级施工项后再修改')
              return
            }
          }else{
            this.$message.error('请选择一级施工项后再修改')
            return
          }
        }
      },
      //删除一级施工项
      delItem(){
        if(this.planTable.id != ""){
          if(this.planTable.parentId == "" || this.planTable.parentId == null){
            this.$confirm('是否确定删除？', '提示', {type: 'info'})
              .then(res => {
                this.$fetchData(this.$api.projPlanTplDetail.del+"/"+this.planTable.id, {} ,'post').then(res => {
                  if(res){
                    this.$message.success('删除成功!')
                    this.refresh()
                  }
                })
              })
              .catch(error => {
                // 点击取消
                this.$message({
                  type: 'info',
                  message: '已取消删除'
                })
              })
          }else{
            this.$message.error('请选择一级施工项后再修改')
            return
          }
        }else{
          this.$message.error('请选择一级施工项后再修改')
          return
        }
      },
      setName(val){
        for (let item of this.constructionItems){
          if(val==item.code){
            this.planTable.name = item.name
          }
        }
      },
      //新增一级施工项
      addItem(){
        if(this.updateType == 'add'){
          for(let a of this.treeDataMenu){
            console.log(a)
            if(a.name == this.planTable.name){
              this.$message.error('一级施工项不能重复添加')
              return
            }
          }
          this.$fetchData(this.$api.projPlanTplDetail.add + "/" + this.id, this.planTable , "post").then(res=>{
            this.dialogItemVisible = false
            this.refresh()
          })
        }else if(this.updateType == 'update'){
          this.$fetchData(this.$api.projPlanTplDetail.edit + "/" + this.planTable.id , this.planTable , "post").then(res=>{
            this.dialogItemVisible = false
            this.refresh()
          })
        }
        this.refresh()
      },
      //关闭一级施工项窗口
      closeWindow(){
        this.dialogItemVisible = false
        this.dialogItemVisibles = false
      },
      //打开新增施工项窗口
      openItems(type,val){
        if(type == "add"){
          console.log(this.planTable)
          this.planTables.name = ''
          this.planTables.parentId = ''
          this.dialogItemVisibles = true
        }else if(type == "update"){
          this.$fetchData(this.$api.projPlanTplDetail.getById+"/"+val,"get").then(res=>{
            this.planTables = res
            this.dialogItemVisibles = true
          })
        }
      },
      //新增施工项
      addItems(){
        this.planTables.parentId = this.planTable.id
        this.planTables.code = this.planTable.code
        console.log(this.planTables)
        this.$fetchData(this.$api.projPlanTplDetail.add+"/"+this.planTable.tplId , this.planTables , "post").then(res=>{
          this.dialogItemVisibles = false
          this.refresh()
        })
      },
      //删除
      del(val){
        this.$confirm('是否确定删除？', '提示', {type: 'info'}).then(res => {
          this.$fetchData(this.$api.projPlanTplDetail.del+"/"+val, {} , "post").then(res=>{
            //刷新树和表
            this.refresh()
            this.handleNodeClick(this.planTable)
          })
        })
      },
      handleNodeClick(obj) {
        console.log(obj)
        this.isShow = true
        this.planTable = obj
        this.$fetchData(this.$api.projPlanTplDetail.getByParentId+"/"+obj.id ,{} , "post").then(res=>{
          this.planTableData = res
        })
        // this.planTable = {}
        // this.checkNode=node
        // if(node.parentId != null){
        //   this.isShow = true
        //   this.planTable.parentId = node.id
        //   this.$fetchData(this.$api.projPlanTplDetail.getByParentId+"/"+this.planTable.parentId ,{} , "post").then(res=>{
        //     this.planTableData=res
        //     if(this.planTableData.length == 0){
        //       this.planTable.parentId = node.id
        //       this.planTable.tplId = node.tplId
        //       this.planTableData.push(this.planTable)
        //     }
        //     console.log(this.planTableData)
        //   })
        // }
      },
      refresh(){
        this.$fetchData(this.$api.projPlanTplDetail.getByTplId+"/"+this.id).then(res=>{
          console.log(res)
          let date = treeUtil.buildTree(res,null,'parentId','id')
          this.treeDataMenu = date
        })
      },
    }
  }
</script>

<style scoped>

</style>
